import { DatasetsOverview } from "@/components/datasets/datasets-overview.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/dashboard/datasets/")({
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.datasets_title()) }],
	}),
});

function RouteComponent() {
	return <DatasetsOverview />;
}
